import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { ImageHelper } from './../../../validator/image-helper';
import { AuthService } from './../../../services/auth.service';
import { MemberService } from './../../../rest/api/member.service';
import { HelperService } from './../../../services/helper.service';
import { SpaceService } from './../../../services/space.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';

import _ from 'lodash';

@Component({
  selector: 'app-upload-images-modal',
  templateUrl: './upload-images-modal.component.html',
  styleUrls: ['./upload-images-modal.component.scss']
})
export class UploadImagesModalComponent implements OnInit {
  @Input() spaceData;
  @Output() uploadImagesEmit = new EventEmitter();
  @ViewChild('imageFile') imageFile: ElementRef;

  accessToken: any;

  public imageSrc = 'assets/images/drag-img.png';
  filesData = [];
  uploadObjErr: any;
  isSubmitted = false;

  uploadObjSuccess: any;
  objUploadResponse = { status: '', message: 0, filePath: '' };

  uploadText = 'Upload';
  progress = 0;

  constructor(
    private authService: AuthService,
    public memberService: MemberService,
    public helperService: HelperService,
    public spaceService: SpaceService
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
  }


  onDropHandler(object) {
    this.uploadObjErr = undefined;
    // this.filesData = [];
    if (object.event.dataTransfer.files.length === 0) { return; }
    const filesData = object.event.dataTransfer.files;
    let i;
    for ( i = 0; i < filesData.length; i++) {
      const fileData = filesData[i];
      fileData.loaded = false;
      const name = fileData.name;
      const fileExtension = name.split('.').pop();
      if (ImageHelper.isImageSizeExceeded(fileData.size)) {
        object.event.target.value = null;
        this.uploadObjErr = 'Please upload file less than 10 MB.';
        return;
      }
      if (fileExtension !== 'jpeg' && fileExtension !== 'png' && fileExtension !== 'jpg') {
        object.event.target.value = null;
        this.uploadObjErr = 'Please upload valid file type (i.e jpeg or png).';
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(fileData); // read file as data url
      reader.onload = (readerevent: any) => { // called once readAsDataURL is completed
        fileData.url = readerevent.target.result;
        fileData.loaded = true;
      };
      this.filesData.push(fileData);
    }

    // this.objStatusErr = undefined;
    // this.uploadObjSuccess = undefined;

    // this.fileUploadForm.get('objFile').setValue(selectedFile);

    // const formData = new FormData();
    // formData.append('file', selectedFile);
    // formData.append('uuid', this.spaceData.uuid);
    // formData.append('type', 'obj');
    // this.spaceService.upload(formData, this.accessToken).subscribe(
    //   (res) =>  {
    //     this.objUploadResponse = res;
    //     if (res && res.success) {
    //       this.uploadObjSuccess = true;
    //     }
    //   },
    //   (err) => this.uploadObjErr = err.message
    // );
  }

  onFileChangeImages(event) {
    this.uploadObjErr = undefined;
    // this.filesData = [];
    if (event.target.files.length === 0) { return; }
    const filesData = event.target.files;
    let i;
    for ( i = 0; i < filesData.length; i++) {
      const fileData = filesData[i];
      fileData.loaded = false;
      const name = fileData.name;
      const fileExtension = name.split('.').pop();
      if (ImageHelper.isImageSizeExceeded(fileData.size)) {
        event.target.value = null;
        this.uploadObjErr = 'Please upload file less than 100 MB.';
        return;
      }
      if (fileExtension !== 'jpeg' && fileExtension !== 'png' && fileExtension !== 'jpg') {
        event.target.value = null;
        this.uploadObjErr = 'Please upload valid file type (i.e jpeg or png).';
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(fileData); // read file as data url
      reader.onload = (readerevent: any) => { // called once readAsDataURL is completed
        fileData.url = readerevent.target.result;
        fileData.loaded = true;
      };
      this.filesData.push(fileData);
    }

    if (this.imageFile) {
      this.imageFile.nativeElement.value = '';
    }

  }

  removeImage(file) {
    this.filesData = _.filter(this.filesData, (f) => {
        return file !== f;
    });
  }

  submit() {
    if (this.filesData.length === 0) {
      this.uploadObjErr = 'Images is required.';
      return;
    }

    if (this.isSubmitted) {
      return;
    }

    this.isSubmitted = true;
    const formData = new FormData();

    let i;
    for ( i = 0; i < this.filesData.length; i++) {
      const fileData = this.filesData[i];
      formData.append('file[]', fileData);
    }
    formData.append('uuid', this.spaceData.uuid);
    formData.append('type', '360');
    // this.spaceService.upload360Image(formData, this.accessToken).subscribe(
    //   (response) =>  {
    //     console.log('repsonse', response);
    //     // this.objUploadResponse = response;
    //     // console.log('percentage', this.objUploadResponse.message);
    //     // if (this.objUploadResponse && this.objUploadResponse.message === 100) {
    //     //   this.uploadText = 'Uploaded';
    //     //   setTimeout(() => {
    //     //     this.uploadText = 'Processing. Please wait';
    //     //   }, 200);

    //     // }
    //     // console.log('this.objUploadResponse', this.objUploadResponse);
    //     // if (response && response.data) {
    //     //   this.uploadObjSuccess = true;
    //     //   this.resetErrorValues();
    //     //   document.getElementById('closeUploadImageModal').click();
    //     //   const responseData = response.data;
    //     //   this.uploadImagesEmit.emit(responseData);
    //     //   this.uploadText = 'Upload';
    //     // }

    //   },
    //   (err) => {
    //     this.uploadText = 'Upload';
    //     try {
    //       this.uploadObjErr = err.error.errors[0].title;
    //     } catch {
    //       this.uploadObjErr = 'Invalid filetype or server response error.';
    //     }
    //     this.isSubmitted = false;
    //   }
    // );

    this.spaceService.upload360Image(formData, this.accessToken).subscribe((event: HttpEvent<any>) => {
      switch (event.type) {
        case HttpEventType.Sent:
          break;
        case HttpEventType.ResponseHeader:
          break;
        case HttpEventType.UploadProgress:
          this.progress = Math.round(event.loaded / event.total * 100);
          if (this.progress === 100) {
            this.uploadText = 'Uploaded';
            setTimeout(() => {
              this.uploadText = 'Processing. Please wait';
            }, 1000);
          }
          break;
        case HttpEventType.Response:
          if (event.body && event.body.data) {
            this.uploadObjSuccess = true;
            this.resetErrorValues();
            document.getElementById('closeUploadImageModal').click();
            const responseData = event.body.data;
            this.uploadImagesEmit.emit(responseData);
            this.uploadText = 'Upload';
            this.progress = 0;
          }
      }
    }, (err) => {
        this.uploadText = 'Upload';
        this.progress = 0;
        try {
          this.uploadObjErr = err.error.errors[0].title;
        } catch {
          this.uploadObjErr = 'Invalid filetype or server response error.';
        }
        this.isSubmitted = false;
      }
    );

  }

  resetErrorValues() {
    this.filesData = [];
    this.isSubmitted = false;
    this.uploadObjErr = undefined;
    this.uploadObjSuccess = undefined;
    if (this.imageFile) {
      this.imageFile.nativeElement.value = '';
    }
  }


}
